import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DesifarmAck } from 'src/app/models/desifarm-common/desifarmAck';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesifarmHeaderService {

  constructor(private http: HttpClient) { }

  get_district(): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'get_district')
  }

  get_area(District_Id): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'get_area/' + District_Id)
  }

  get_sub_area(Area_Id): Observable<any> {
    return this.http.post<DesifarmAck>(environment.url + 'get_sub_area', { Area_Id })
  }

  get_all_areas(): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'get_all_areas')
  }

  get_all_sub_areas(): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'get_all_sub_areas')
  }

  relationship_manager_by_subarea(Sub_Area_Id): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'relationship_manager_by_subarea/' + Sub_Area_Id)
  }

  relationship_manager_by_staff(Staff_Id): Observable<any> {
    return this.http.get<DesifarmAck>(environment.url + 'relationship_manager_by_staff/' + Staff_Id)
  }

  search_products_name_list(data): Observable<any> {
    return this.http.post<DesifarmAck>(`${environment.url}search_products_name_list`, data)
  }



}
